export default "images/postman-logo.png";